import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";
import Header from "@/components/landing/Header";
import PageFooter from "@/components/landing/PageFooter";
import NewsletterSignup from "@/components/landing/NewsletterSignup";
import GroupProgramsIntro from "@/components/programs/GroupProgramsIntro";
import GroupProgramCard from "@/components/programs/GroupProgramCard";
import GroupRegistrationForm from "@/components/programs/GroupRegistrationForm";
import { Reveal } from "@/components/home/homeUi";
import { GROUP_PROGRAMS } from "@/data/groupPrograms";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function CurrentPrograms() {
  const [selected, setSelected] = useState("");
  const [data, setData] = useState(null);

  const load = useCallback(() => {
    axios
      .get(`${API}/group-programs`)
      .then((r) => setData(r.data))
      .catch(() => setData((d) => d || { registration_enabled: false, programs: GROUP_PROGRAMS }));
  }, []);

  useEffect(load, [load]);
  const programs = data?.programs || [];

  const handleApply = (id) => {
    setSelected(id);
    document.getElementById("jelentkezes")?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <main data-testid="current-programs-page" className="bg-warm text-graphite min-h-screen">
      <Header />
      <div className="pt-20 md:pt-24" />
      <GroupProgramsIntro />

      <section id="alkalmak" data-testid="group-programs-list" className="px-5 md:px-10 py-14 md:py-20 bg-tinted border-t border-hairline">
        <Reveal className="text-center mb-10 md:mb-14">
          <h2
            data-testid="group-programs-list-title"
            className="font-serif-display text-[30px] sm:text-[36px] md:text-[44px] leading-[1.18] text-graphite max-w-3xl mx-auto"
          >
            Aktuális <em className="text-gold" style={{ fontStyle: "italic" }}>kiscsoportos alkalmak</em>
          </h2>
        </Reveal>
        <div className="max-w-4xl mx-auto space-y-8 md:space-y-10 min-h-[320px]" data-testid="group-programs-cards">
          {programs.map((p) => (
            <GroupProgramCard key={p.id} program={p} onApply={handleApply} />
          ))}
        </div>
      </section>

      <section id="jelentkezes" data-testid="group-registration" className="px-5 md:px-10 pt-10 md:pt-12 pb-14 md:pb-16 bg-tinted border-t border-hairline scroll-mt-24">
        <div className="max-w-5xl mx-auto">
          <h2 data-testid="group-registration-title" className="text-center font-serif-display text-[32px] sm:text-[38px] md:text-[44px] leading-[1.18] text-graphite mb-7 md:mb-8">
            Szeretettel várlak a <em className="text-gold" style={{ fontStyle: "italic" }}>közös térben!</em>
          </h2>
          <p data-testid="group-registration-intro" className="reading-prose font-body font-light text-graphite text-[16px] md:text-[17px] leading-[1.9]">
            Ha valamelyik program megszólított, az alábbi űrlapon tudod jelezni a részvételi szándékodat.{" "}
            {data?.emails_enabled && "A jelentkezés elküldése után automatikus visszaigazolást kapsz az általad megadott e-mail-címre. "}
            A részvétellel és a fizetéssel kapcsolatos további információkat ezt követően személyesen küldöm el neked. A helyed a részvételi díj beérkezésével válik véglegessé.
          </p>
        </div>
        <div className="max-w-4xl mx-auto">
          <GroupRegistrationForm selectedProgramId={selected} programs={programs} enabled={!!data?.registration_enabled} onSubmitted={load} />
        </div>
      </section>

      <NewsletterSignup source="aktualis-programok" />
      <PageFooter />
    </main>
  );
}
